import React, { memo } from "react";
import { LayersControl, WMSTileLayer } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";

const MAP_CACHE = 'https://mapcache.terras.agr.br/mapcache_terras';
const MAP_SPT = 'https://mapcache.terras.agr.br/mapcache2/'

const MapCache = memo(({ position = 'topright' }) => {
  const layersToAdd = [
    // ── MAP_CACHE ──────────────────────────────────────────
    { layers: 'municipios', label: 'Municípios', color: 'rgb(255,255,255)', source: 'MAP_CACHE' },
    { layers: 'terra_indigenas', label: 'Terras Indigenas', color: 'rgb(255,211,122)', source: 'MAP_CACHE' },
    { layers: 'terra_indigenas_za', label: 'Terras Indigenas - ZA', color: 'rgb(255,211,122)', source: 'MAP_CACHE' },
    { layers: 'uc_za', label: 'Unidades de Conservação - ZA', color: 'rgb(255,157,130)', source: 'MAP_CACHE' },
    { layers: 'ucm', label: 'Unidades de Conservação Municipal', color: 'rgb(186,221,128)', source: 'MAP_CACHE' },
    { layers: 'uce', label: 'Unidades de Conservação Estadual', color: 'rgb(230,230,0)', source: 'MAP_CACHE' },
    { layers: 'ucf', label: 'Unidades de Conservação Federal', color: 'rgb(100,100,100)', source: 'MAP_CACHE' },
    { layers: 'assentamentos', label: 'Incra: Assentamentos', color: 'rgb(200,154,8)', source: 'MAP_CACHE' },
    { layers: 'quilombos', label: 'Incra: Quilombos', color: 'rgb(255,255,127)', source: 'MAP_CACHE' },
    { layers: 'sigef_imoveis_privados', label: 'Incra: Imóvel certificado SIGEF Privado', color: 'rgb(177,89,40)', source: 'MAP_CACHE' },
    { layers: 'sigef_snci_privados', label: 'Incra: Imóvel certificado SNCI Privado', color: 'rgb(177,89,40)', source: 'MAP_CACHE' },
    { layers: 'cnfp_tipo_b', label: 'Floresta tipo B', color: 'rgb(200,50,50)', source: 'MAP_CACHE' },
    { layers: 'ibama_embargos', label: 'Ibama: Embargos', color: 'rgb(240,240,240)', source: 'MAP_CACHE' },
    { layers: 'bioma', label: 'MMA: Bioma', color: 'rgb(255,255,255)', source: 'MAP_CACHE' },
    { layers: 'vegetacao', label: 'Vegetação', color: 'rgb(255,255,255)', source: 'MAP_CACHE' },

    // ── MAP_SPT ────────────────────────────────────────────
    { layers: 'aptidao_agr_bra', label: 'Aptidão Agrícola', color: 'rgb(100,180,100)', source: 'MAP_SPT' },
    { layers: 'sicor_glebas_geom', label: 'Sicor: Glebas', color: 'rgb(80,120,200)', source: 'MAP_SPT' },
    { layers: 'topodata_slope', label: 'Topodata: Declividade INPE', color: 'rgb(200,100,100)', source: 'MAP_SPT' },
    { layers: 'deter_degradation', label: 'DETER: Degradação de Solo', color: 'rgb(255,0,0)', source: 'MAP_SPT' },
  ];

  const getUrl = (source) => (source === 'MAP_SPT' ? MAP_SPT : MAP_CACHE);

  return (
    <LayersControl position={position}>
      {layersToAdd.map(layer => (
        <LayersControl.Overlay
          name={`<div style='background-color:${layer.color}' class='tiny-box'></div>${layer.label}`}
          key={layer.layers}
        >
          <WMSTileLayer
            url={getUrl(layer.source)}
            layers={layer.layers}
            transparent={true}
            format="image/png"
            opacity={0.5}
          />
        </LayersControl.Overlay>
      ))}
    </LayersControl>
  );
});

export default MapCache;